import React from 'react'
import { Route, Switch } from 'react-router-dom'

import ParentAccountPage from './ParentAccountPage'
import AccountPage from './AccountPage'
import OfficePage from './OfficePage'
import ClientRecordsSearchPage from './ClientRecordsSearchPage'

export default () => (
  <Switch>
    <Route path='/client-search' component={ClientRecordsSearchPage} />
    <Route
      path='/parent-account/:id'
      render={props => (
        <ParentAccountPage {...props} key={props.match.params.id} />
      )}
    />
    <Route
      path='/account/:id'
      render={props => <AccountPage {...props} key={props.match.params.id} />}
    />
    <Route
      path='/office/:id'
      render={props => <OfficePage {...props} key={props.match.params.id} />}
    />
  </Switch>
)

export { ParentAccountPage, AccountPage, OfficePage, ClientRecordsSearchPage }
